import { AttributeBaseModel } from './AttributeBaseModel';
export class UInt160AttributeModel extends AttributeBaseModel {
    constructor({ usage, value }) {
        super();
        this.usage = usage;
        this.value = value;
    }
    serializeWireBase(writer) {
        super.serializeWireBase(writer);
        writer.writeUInt160(this.value);
    }
}

//# sourceMappingURL=UInt160AttributeModel.js.map
